
import { defineComponent } from "vue";
import { XrplClient, Call } from "xrpl-client";
import { utils } from "xrpl-txdata";

interface XrplPathComponent {
  currency?: string;
  issuer?: string;
  type: number;
}

interface XrplCurrency {
  currency: string;
  issuer: string;
  value: string;
}

interface XrplPath {
  paths_canonical: XrplPathComponent[];
  paths_computed: XrplPathComponent[];
  source_amount: XrplCurrency | number;
}

type XrplPaths = XrplPath[];

let watchToGo: ReturnType<typeof setTimeout>;

let paths: XrplPaths = [];

export default defineComponent({
  name: "PathFinder",
  data() {
    return {
      lastId: "",
      loading: true,
      error: "",
      pfResults: {},
      paths,
      command: {},
    };
  },
  props: {
    xrpl: XrplClient,
    params: Object,
  },
  computed: {},
  watch: {
    params: {
      deep: true,
      handler() {
        this.pfResults = {};
        this.loading = true;
        this.error = "";

        clearTimeout(watchToGo);
        watchToGo = setTimeout(() => {
          this.go();
        }, 3_000);
      },
    },
  },
  mounted() {
    console.log(this.params?.destination);
    console.log(this.params?.source);
    this.go();
  },
  methods: {
    rand(size: number) {
      return [...Array(size)]
        .map(() => Math.floor(Math.random() * 16).toString(16))
        .join("");
    },
    currencyCodeFormat(code: string) {
      return utils.currencyCodeFormat(code);
    },
    async go() {
      this.loading = true;
      this.error = "";

      this.xrpl?.send({
        id: this.lastId,
        command: "path_find",
        subcommand: "close",
      });

      this.lastId = this.rand(6);

      const command: Call = {
        id: this.lastId,
        command: "path_find",
        subcommand: "create",
        source_account: this.params?.source?.account || "",
        destination_account: this.params?.destination?.account || "",
        destination_amount:
          (this.params?.destination?.asset || "") === "XRP"
            ? String(
                (Number(this.params?.destination?.amount || 0) || 0) * 1_000_000
              )
            : {
                value: this.params?.destination?.amount || "0",
                currency: this.params?.destination?.asset || "",
                issuer: this.params?.destination?.account || "",
              },
      };

      console.log("Pathfinding command", { command });

      this.command = command;

      const results = await this.xrpl?.send(command);
      console.log("pfcall", { command, results });

      this.paths = (results?.result?.alternatives || []) as XrplPaths;

      this.xrpl?.on("path", (path) => {
        if (path?.destination_amount) {
          console.log("Async path", path.id, path.id === this.lastId, path);
          if (path.id === this.lastId) {
            this.paths = (path?.alternatives || []) as XrplPaths;
          } else {
            // Old command, close
            this.xrpl?.send({
              id: path.id,
              command: "path_find",
              subcommand: "close",
            });
          }
        }
      });

      this.loading = false;

      if (results?.error) {
        this.error = (results.error + " " + results?.error_message).trim();
      }

      return results;
    },
  },
});
